module.exports = __webpack_public_path__ + "img/table.e726fead.svg";